// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opt-popper{padding:8px 10px;min-width:auto!important;box-sizing:border-box}.opt-popper .operate-btn-list{font-size:12px;line-height:17px;text-align:center}.opt-popper .operate-btn-list li{cursor:pointer}.opt-popper .operate-btn-list li:hover{opacity:.7}.opt-popper .operate-btn-list .rename-btn{margin-bottom:6px;padding-bottom:6px;color:#00aea5;border-bottom:1px solid #ddd}.opt-popper .operate-btn-list .delete-btn{color:#e02020}", ""]);
// Exports
module.exports = exports;
